export const FEATURE_TOGGLES = {
  TEST_TOGGLE: 'test-toggle',
  TOTAL_REVENUE_STRATEGY_TAB: 'total-revenue-strategy-tab',
  PI_MULTI_POS: 'parity-insight-multi-pos', // Cleanup ticket: PI-1553
  CENTRAL_CURRENCY_CONVERSION: 'central-currency-conversion',
  CONTEXTUAL_TAB_NAMING: 'contextual-tab-naming',
  UNIFIED_HOTEL_VIEW: 'unified-hotel-view', // Cleanup ticket: CPS-541
  PRICING_MANAGER_OVERBOOKING_AUTOPILOT:
    'pricing-manager-overbooking-autopilot', // Cleanup ticket: COA-3299
  PRICING_MANAGER_ROOM_HIERARCHY_ROOM_OFFSETS:
    'pricing-manager-room-hierarchy-room-offsets', // Cleanup ticket: COA-3437
  ROLLING_WINDOW_REFERENCE_RATES: 'rolling-window-reference-rates', // Cleanup ticket: COA-3480
  SETTINGS_UNIFIED_SETTINGS: 'unified-settings', // Cleanup ticket: INDU-1300
  MIN_LOS_STAY_RESTRICTION_TOOLTIP: 'min-los-stay-restriction-tooltip', // Cleanup ticket: COA-3553
  SMART_INSIGHTS_IN_MRT: 'smart-insights-in-mrt', // Cleanup ticket: COA-3535
  ERNEST: 'ernest',
  USER_ACCESS: 'user-access', // Cleanup ticket: CPS-747
  BI_SNAPSHOTS: 'business-intelligence-snapshots', // Cleanup ticket: PF-2226
  DAY_OVERRIDE_MODAL_RESTRICTIONS_TAB: 'day-override-modal-restrictions-tab',
} as const;
export type FeatureToggle =
  (typeof FEATURE_TOGGLES)[keyof typeof FEATURE_TOGGLES];
